module.exports = __webpack_public_path__ + "static/media/10.question.66bc97c4.mp4";